import { openBlock as t, createElementBlock as h, createStaticVNode as l } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, e = /* @__PURE__ */ l('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#0052B4" d="M20 0C8.954 0 0 8.954 0 20c0 2.446.44 4.79 1.244 6.956h37.512A19.957 19.957 0 0 0 40 20C40 8.954 31.046 0 20 0Z"></path><path fill="#D80027" d="M20 0C11.4 0 4.07 5.427 1.244 13.043h37.512C35.93 5.428 28.599 0 20 0Z"></path><path fill="#D80027" d="M5.172 13.043v8.238c0 5.676 7.414 7.415 7.414 7.415S20 26.956 20 21.28v-8.238H5.172Z"></path><path fill="#FFDA44" d="M8.238 13.043h8.696V9.566l-1.74.87-2.608-2.609-2.609 2.609-1.739-.87v3.479ZM18.26 22.67l-5.651-5.652-5.653 5.652 1.845 1.845 3.808-3.808 3.807 3.808 1.845-1.845Z"></path><path fill="#F0F0F0" d="M18.26 17.391h-2.636a1.74 1.74 0 1 0-3.038-1.69 1.739 1.739 0 1 0-3.038 1.69H6.957c0 .96.836 1.74 1.797 1.74h-.058c0 .96.778 1.739 1.739 1.739 0 .85.61 1.557 1.417 1.708l-1.37 3.094a5.634 5.634 0 0 0 2.127.415c.752 0 1.47-.148 2.127-.415l-1.37-3.094a1.739 1.739 0 0 0 1.417-1.708 1.74 1.74 0 0 0 1.739-1.74h-.058c.96 0 1.797-.778 1.797-1.739Z"></path>', 6), c = [
  e
];
function o(p, i) {
  return t(), h("svg", a, [...c]);
}
const d = { render: o };
export {
  d as default,
  o as render
};
